export enum EFinancingProductId {
  AGENT = 'AGENT',
  SBERPAY = 'SBERPAY',
  BNPL_AGROINTEGRATOR = 'BNPL_AGROINTEGRATOR',
  MARKETPLACE = 'MARKETPLACE',
  EXPRESS_LOAN = 'EXPRESS_LOAN',
  TINKOFF_REVOLVING_LOAN = 'TINKOFF_REVOLVING_LOAN',
  ALFA_EXPRESS_LOAN = 'ALFA_EXPRESS_LOAN',
  REVOLVING_LOAN = 'REVOLVING_LOAN',
  ADVANCE_FUNDING = 'ADVANCE_FUNDING',
  REVOLVING_LOAN_SBER = 'SBER_OBOROTKA_LOAN',
  LEASING_RAL = 'LEASING_RAL',
  LEASING_VTB = 'LEASING_VTB',
  LEASING_INTERLEASING = 'LEASING_INTERLEASING',
  LEASING_BALTIYSKIY = 'LEASING_BALTIYSKIY',
  LEASING_ALFA = 'LEASING_ALFA',
  LEASING_STONE_XXI = 'LEASING_STONE',
  LEASING_FLEET_FINANCE = 'LEASING_FLEET_FINANCE',
  INVESTMENT = 'INVESTMENT',
  VTB_COMMON = 'VTB_COMMON',
  EXPRESS_MFO = 'EXPRESS_MFO',
  AGROINTEGRATOR = 'AGROINTEGRATOR',
  MONEY_KAPITAL = 'MONEY_KAPITAL',
  SBER_LEASING = 'SBER_LEASING',
  SBER_INVESTMENT_LOAN = 'SBER_INVESTMENT_LOAN',
  SBER_OBOROTKA_LOAN = 'SBER_OBOROTKA_LOAN',
  CENTER_INVEST_LOAN = 'CENTER_INVEST_BANK',
  MULTI_LEASING = 'MULTI_LEASING',
  LOMBARD_LOAN_ALFA_BANK = 'LOMBARD_LOAN_ALFA_BANK',
  BNPL_MANDARIN = 'BNPL_MANDARIN',
  BNPL_POLECREDIT = 'BNPL_POLECREDIT',
  REPORT_CTRL2GO = 'REPORT_CTRL2GO',
}
